module.exports = __webpack_public_path__ + "img/1477008942.cde5784e.jpg";